import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";

export default class InitMapsConfigTask extends Task {
    constructor(assetLibrary, mapsConfig) {
        super();

        this.execute = (callback, progressCallback) => {
            const mapsJson = assetLibrary.getAsset("maps-config");
            mapsConfig.setPropertiesFromObject(mapsJson);

            callback(this);
        }
    }
}